export default __webpack_public_path__ + "static/media/Confectionery1.a9a3abc9.png";